"use client";

import { useUserAuthDataContext } from "@/global-context/user-auth-context";
import { handleEmailNotificationsClick } from "../handlers";
import { useUserDataContext } from "../user-data-context";
import styles from "./card.module.css";
import Switcher, { SwitcherLoading } from "./switcher";
import { useTranslations } from "next-intl";

export default function OthersCard() {
  const { userData } = useUserAuthDataContext();
  const { state, updateField } = useUserDataContext();
  const t = useTranslations("MyAccount");

  return (
    <div className={styles.cardWrapper}>
      <div className={styles.detailsWrapper}>
        <div className={styles.switcherRow}>
          <p>{t("notifications")}</p>
          <Switcher
            isActive={state.email_notifications}
            onClickAction={async () => {
              await handleEmailNotificationsClick(
                state.email_notifications,
                (newValue) => {
                  updateField("email_notifications", newValue);
                },
                userData.sessionId
              );
            }}
            aria-label={t("ariaToggleNotifications")}
          />
        </div>
      </div>
      <button className={styles.button} aria-label={t("ariaDeleteAccount")}>
        {t("deleteAccount")}
      </button>
    </div>
  );
}

export function OthersCardLoading() {
  return (
    <div className={styles.cardWrapper}>
      <div className={styles.detailsWrapper}>
        <div className={styles.switcherRow} style={{ gap: "16px" }}>
          <div style={{ width: "100%" }}>
            <p
              className={styles.isLoading}
              style={{ width: "100%", marginBottom: "4px" }}
            ></p>
            <p className={styles.isLoading} style={{ width: "70%" }}></p>
          </div>
          <SwitcherLoading />
        </div>
      </div>
      <button className={`${styles.button} ${styles.isLoading}`}></button>
    </div>
  );
}
